<template>
  <div class="page-domain-forwarding">
    <Overlay
      width="x-small"
      autoHeight
      :link="{name: 'company-domain'}">

      <Notification
        v-if="notification.active"
        :withinOverlay="true"
        :content="notification.content"
        :type="notification.type"/>

      <h2 class="overlay-heading">URL Forwarding</h2>

      <DomainForwardingForm
        :domain="domain"
        @submit="submit"
        :errors="errors"
        v-model="forwardTo" />
    </Overlay>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import {readCompanyData} from '@/lib/companies'
import {createCompanyDomainForwardingData} from '@/lib/domains'

import Overlay from '@/components/Overlay'
import DomainForwardingForm from '@/components/forms/DomainForwardingForm'

export default {
  name: 'add-domain-forwarding',

  mixins: [page, notification],

  props: {
    companyId: {
      type: String,
      required: true
    },

    domain: {
      type: String,
      required: true
    }
  },

  components: {
    Overlay,
    DomainForwardingForm
  },

  data() {
    return {
      forwardTo: {}
    }
  },

  methods: {
    getData() {
      readCompanyData(this.companyId).then(({data}) => {
        this.company = data
      })
    },

    submit() {
      let domain = {
        host: this.domain,
        forwards_to: this.forwardTo.forwardsTo,
        type: 'redirect'
      }

      createCompanyDomainForwardingData(this.companyId, this.domain, domain)
        .then(({data}) => {
          this.triggerNotification('success', 'forwarding', 'created')

          window.setTimeout(() => {
            this.$router.push({name: 'company-domain'})
          }, this.closeDelay)
        })
    }
  },

  computed: {
    title() {
      return `${this.domain} URL Forwarding`
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    $route() {
      this.getData()
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'
</style>
